import { NextPage } from 'next'
import DefaultErrorPage from 'next/error'
import { BookDetail } from 'web_core/assets/book'
import { LoadingSpinner } from 'web_core/assets/spinners'
import { PrintSettingProvider } from 'web_core/context/print_setting'
import { usePVCounter } from 'web_core/hooks'
import { getDefaultStaticPaths } from 'web_core/utils/static_paths'
import { DefaultLayout } from '~/components/Layout/Default'
import { useBookPageProps } from '~/hooks/useBookPageProps'
import { BookPageProps, getBookPageStaticProps } from '~/static_props/book'

export const getStaticPaths = getDefaultStaticPaths

export const getStaticProps = getBookPageStaticProps

const Page: NextPage<BookPageProps> = (props) => {
  const {
    isNotFound,
    book,
    pages,
    profile,
    category,
    tags,
    references,
    macros,
    indexable,
    badges,
  } = useBookPageProps(props)

  usePVCounter(book?.ref ?? null)

  if (isNotFound) return <DefaultErrorPage statusCode={404} />

  return (
    <DefaultLayout
      head={{
        title: book?.title ?? 'タイトル不明な本',
        description: book?.description,
        keyword: tags?.map((tag) => tag.name).join(', '),
        index: indexable,
      }}
      header={{ hideNewContentsButton: true, hideSearchField: true }}
      maxWidth={800}
    >
      <PrintSettingProvider>
        {book &&
        pages &&
        profile &&
        category &&
        tags &&
        references &&
        macros &&
        badges ? (
          <BookDetail
            book={book}
            pages={pages}
            profile={profile}
            category={category}
            tags={tags}
            references={references}
            macros={macros}
            badges={badges}
          />
        ) : (
          <LoadingSpinner />
        )}
      </PrintSettingProvider>
    </DefaultLayout>
  )
}

export default Page
